
// 通讯实例
import mitt from 'mitt'
const eventHub = mitt()
export { eventHub }
